export default __webpack_public_path__ + "static/media/ibank.cf44367d.svg";